/**
 * 全球排放控制区
 */
export const ECAv2 = [
  {
    name: '夏威夷',
    property: '密闭',
    status: '已生效',
    emissionType: 'Nox，SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 22.54833333, lon: -153.0091667 },
          { lat: 23.10138889, lon: -153.4766667 },
          { lat: 23.53638889, lon: -154.0366667 },
          { lat: 23.86305556, lon: -154.6133333 },
          { lat: 24.36361111, lon: -155.8536111 },
          { lat: 24.69638889, lon: -156.4575 },
          { lat: 24.95916667, lon: -157.3713889 },
          { lat: 25.22805556, lon: -157.9036111 },
          { lat: 25.42527778, lon: -158.51 },
          { lat: 25.52194444, lon: -159.1630556 },
          { lat: 25.50861111, lon: -159.9058333 },
          { lat: 25.36472222, lon: -160.6647222 },
          { lat: 25.00166667, lon: -161.6425 },
          { lat: 24.68027778, lon: -162.2202778 },
          { lat: 24.26472222, lon: -162.7188889 },
          { lat: 23.68055556, lon: -163.2166667 },
          { lat: 23.05555556, lon: -163.5494444 },
          { lat: 22.33583333, lon: -163.7447222 },
          { lat: 21.6125, lon: -163.7675 },
          { lat: 20.92388889, lon: -163.6288889 },
          { lat: 20.22611111, lon: -163.3202778 },
          { lat: 19.65083333, lon: -162.8966667 },
          { lat: 19.16194444, lon: -162.3430556 },
          { lat: 18.65444444, lon: -161.3205556 },
          { lat: 18.50861111, lon: -160.6416667 },
          { lat: 18.49194444, lon: -159.9380556 },
          { lat: 18.17805556, lon: -159.2355556 },
          { lat: 17.52138889, lon: -158.9486111 },
          { lat: 16.90166667, lon: -158.5080556 },
          { lat: 16.43027778, lon: -157.9902778 },
          { lat: 15.99916667, lon: -157.2930556 },
          { lat: 15.67694444, lon: -156.3516667 },
          { lat: 15.62666667, lon: -155.3711111 },
          { lat: 15.72944444, lon: -154.7769444 },
          { lat: 15.92555556, lon: -154.2180556 },
          { lat: 16.77416667, lon: -152.8197222 },
          { lat: 17.56166667, lon: -152.0088889 },
          { lat: 18.50444444, lon: -151.5066667 },
          { lat: 19.04638889, lon: -151.3713889 },
          { lat: 19.57944444, lon: -151.3297222 },
          { lat: 20.12833333, lon: -151.3827778 },
          { lat: 20.64527778, lon: -151.5266667 },
          { lat: 21.48583333, lon: -151.9972222 },
          { lat: 22.11611111, lon: -152.5236111 },
          { lat: 22.54833333, lon: -153.0091667 },
        ],
      },
    ],
  },
  {
    name: '美国西海岸',
    property: '开放',
    status: '已生效',
    emissionType: 'Nox，SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 32.53611111, lon: -117.1030556 },
          { lat: 32.53444444, lon: -117.1247222 },
          { lat: 32.5275, lon: -117.2388889 },
          { lat: 32.55361111, lon: -117.2638889 },
          { lat: 32.5725, lon: -117.3669444 },
          { lat: 32.58972222, lon: -117.4647222 },
          { lat: 32.62722222, lon: -117.8261111 },
          { lat: 31.13305556, lon: -118.6058333 },
          { lat: 30.55694444, lon: -121.7913889 },
          { lat: 31.76972222, lon: -123.2894444 },
          { lat: 32.36611111, lon: -123.8455556 },
          { lat: 32.94416667, lon: -124.1963889 },
          { lat: 33.67, lon: -124.4541667 },
          { lat: 34.52444444, lon: -125.2811111 },
          { lat: 35.24388889, lon: -125.7230556 },
          { lat: 35.73333333, lon: -126.3147222 },
          { lat: 36.27361111, lon: -126.7583333 },
          { lat: 37.02638889, lon: -127.1216667 },
          { lat: 37.76083333, lon: -127.6338889 },
          { lat: 38.41888889, lon: -127.8833333 },
          { lat: 39.41805556, lon: -128.5230556 },
          { lat: 40.31305556, lon: -128.7627778 },
          { lat: 41.2275, lon: -128.6727778 },
          { lat: 42.21361111, lon: -129.0105556 },
          { lat: 42.79277778, lon: -129.095 },
          { lat: 43.43944444, lon: -129.0238889 },
          { lat: 44.41194444, lon: -128.6897222 },
          { lat: 45.51194444, lon: -128.6672222 },
          { lat: 46.18361111, lon: -128.8169444 },
          { lat: 46.56527778, lon: -129.0747222 },
          { lat: 47.66527778, lon: -131.2613889 },
          { lat: 48.54222222, lon: -132.6833333 },
          { lat: 48.96305556, lon: -133.2463889 },
          { lat: 49.3775, lon: -134.2641667 },
          { lat: 50.03111111, lon: -135.3169444 },
          { lat: 51.055, lon: -136.7625 },
          { lat: 51.90111111, lon: -137.6983333 },
          { lat: 52.75333333, lon: -138.3372222 },
          { lat: 53.48888889, lon: -138.6766667 },
          { lat: 53.6775, lon: -138.8147222 },
          { lat: 54.22916667, lon: -139.5438889 },
          { lat: 54.65694444, lon: -139.9386111 },
          { lat: 55.33833333, lon: -140.9291667 },
          { lat: 56.12, lon: -141.605 },
          { lat: 56.47555556, lon: -142.2886111 },
          { lat: 56.62194444, lon: -142.8158333 },
          { lat: 58.85111111, lon: -153.2508333 },
        ],
      },
    ],
  },
  {
    name: '美国东海岸',
    property: '开放',
    status: '已生效',
    emissionType: 'Nox，SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 60, lon: -64.16 },
          { lat: 60, lon: -56.71666667 },
          { lat: 58.90027778, lon: -55.63472222 },
          { lat: 57.84777778, lon: -55.06305556 },
          { lat: 57.58694444, lon: -54.01638889 },
          { lat: 57.23888889, lon: -53.13277778 },
          { lat: 56.8025, lon: -52.39138889 },
          { lat: 56.30361111, lon: -51.82833333 },
          { lat: 54.38916667, lon: -50.29555556 },
          { lat: 53.74833333, lon: -50.12138889 },
          { lat: 53.08305556, lon: -50.16805556 },
          { lat: 52.335, lon: -49.9525 },
          { lat: 51.57222222, lon: -48.87916667 },
          { lat: 50.67083333, lon: -48.26777778 },
          { lat: 50.04111111, lon: -48.1175 },
          { lat: 49.40083333, lon: -48.15972222 },
          { lat: 48.65611111, lon: -47.92138889 },
          { lat: 47.40694444, lon: -47.78222222 },
          { lat: 46.58666667, lon: -48.015 },
          { lat: 45.32916667, lon: -48.72444444 },
          { lat: 44.72722222, lon: -49.28055556 },
          { lat: 44.27722222, lon: -49.85638889 },
          { lat: 43.8875, lon: -50.56694444 },
          { lat: 43.60166667, lon: -51.34472222 },
          { lat: 43.39972222, lon: -52.28944444 },
          { lat: 43.33055556, lon: -53.33694444 },
          { lat: 43.35388889, lon: -54.15555556 },
          { lat: 43.49472222, lon: -55.12805556 },
          { lat: 42.67, lon: -55.52888889 },
          { lat: 41.97194444, lon: -56.15944444 },
          { lat: 41.33916667, lon: -57.08694444 },
          { lat: 40.92611111, lon: -58.04861111 },
          { lat: 40.69388889, lon: -59.08833333 },
          { lat: 40.6425, lon: -60.20555556 },
          { lat: 40.76277778, lon: -61.23416667 },
          { lat: 41.08111111, lon: -62.29694444 },
          { lat: 40.61527778, lon: -63.18027778 },
          { lat: 40.29222222, lon: -64.14361111 },
          { lat: 40.12944444, lon: -64.99194444 },
          { lat: 40.09555556, lon: -65.88527778 },
          { lat: 39.96805556, lon: -65.9975 },
          { lat: 39.47333333, lon: -66.35388889 },
          { lat: 39.03166667, lon: -66.80916667 },
          { lat: 38.65444444, lon: -67.34972222 },
          { lat: 38.32222222, lon: -68.03361111 },
          { lat: 38.09138889, lon: -68.78194444 },
          { lat: 37.97055556, lon: -69.56861111 },
          { lat: 37.96305556, lon: -70.4025 },
          { lat: 37.87944444, lon: -70.63055556 },
          { lat: 37.31027778, lon: -71.1425 },
          { lat: 36.54027778, lon: -71.56638889 },
          { lat: 35.58277778, lon: -71.43388889 },
          { lat: 34.55277778, lon: -71.61777778 },
          { lat: 33.91361111, lon: -71.87638889 },
          { lat: 33.32305556, lon: -72.28666667 },
          { lat: 32.75861111, lon: -72.90138889 },
          { lat: 31.92027778, lon: -74.20055556 },
          { lat: 31.45388889, lon: -75.25555556 },
          { lat: 31.05444444, lon: -75.855 },
          { lat: 30.76166667, lon: -76.52722222 },
          { lat: 30.21333333, lon: -77.30805556 },
          { lat: 29.42138889, lon: -76.945 },
          { lat: 28.61638889, lon: -76.8 },
          { lat: 28.28694444, lon: -76.66944444 },
          { lat: 28.28666667, lon: -79.18972222 },
          { lat: 27.88222222, lon: -79.47638889 },
          { lat: 27.43361111, lon: -79.52722222 },
          { lat: 27.27027778, lon: -79.57166667 },
          { lat: 27.19833333, lon: -79.58222222 },
          { lat: 27.09972222, lon: -79.58861111 },
          { lat: 27.00777778, lon: -79.58805556 },
          { lat: 26.92111111, lon: -79.5775 },
          { lat: 26.89944444, lon: -79.57416667 },
          { lat: 26.76277778, lon: -79.54472222 },
          { lat: 26.74166667, lon: -79.53972222 },
          { lat: 26.72777778, lon: -79.53888889 },
          { lat: 26.68666667, lon: -79.53361111 },
          { lat: 26.63694444, lon: -79.52555556 },
          { lat: 26.60833333, lon: -79.51833333 },
          { lat: 26.58916667, lon: -79.51388889 },
          { lat: 26.58083333, lon: -79.51277778 },
          { lat: 26.56972222, lon: -79.51055556 },
          { lat: 26.52, lon: -79.50416667 },
          { lat: 26.48472222, lon: -79.49805556 },
          { lat: 26.42527778, lon: -79.49944444 },
          { lat: 26.39138889, lon: -79.49861111 },
          { lat: 26.38916667, lon: -79.49833333 },
          { lat: 26.31583333, lon: -79.53194444 },
          { lat: 26.25722222, lon: -79.55472222 },
          { lat: 26.25361111, lon: -79.55638889 },
          { lat: 26.13583333, lon: -79.59805556 },
          { lat: 26.12972222, lon: -79.6025 },
          { lat: 26.11638889, lon: -79.60972222 },
          { lat: 26.04777778, lon: -79.63944444 },
          { lat: 25.99166667, lon: -79.6675 },
          { lat: 25.98777778, lon: -79.66888889 },
          { lat: 25.96333333, lon: -79.67722222 },
          { lat: 25.93833333, lon: -79.685 },
          { lat: 25.90111111, lon: -79.69388889 },
          { lat: 25.89, lon: -79.69611111 },
          { lat: 25.865, lon: -79.69972222 },
          { lat: 25.82583333, lon: -79.70444444 },
          { lat: 25.80666667, lon: -79.70638889 },
          { lat: 25.80555556, lon: -79.70666667 },
          { lat: 25.77388889, lon: -79.71222222 },
          { lat: 25.77111111, lon: -79.7125 },
          { lat: 25.72777778, lon: -79.71638889 },
          { lat: 25.70861111, lon: -79.71333333 },
          { lat: 25.67694444, lon: -79.7075 },
          { lat: 25.62333333, lon: -79.7075 },
          { lat: 25.61888889, lon: -79.7075 },
          { lat: 25.5175, lon: -79.70333333 },
          { lat: 25.46638889, lon: -79.70305556 },
          { lat: 25.40111111, lon: -79.70333333 },
          { lat: 25.3725, lon: -79.70555556 },
          { lat: 25.35805556, lon: -79.70222222 },
          { lat: 25.28111111, lon: -79.69 },
          { lat: 25.26583333, lon: -79.69194444 },
          { lat: 25.1775, lon: -79.69194444 },
          { lat: 25.16416667, lon: -79.69333333 },
          { lat: 25.15083333, lon: -79.69583333 },
          { lat: 25.06527778, lon: -79.70805556 },
          { lat: 25.05, lon: -79.71555556 },
          { lat: 25.00833333, lon: -79.73472222 },
          { lat: 24.98416667, lon: -79.74666667 },
          { lat: 24.92444444, lon: -79.76583333 },
          { lat: 24.73833333, lon: -79.82333333 },
          { lat: 24.71777778, lon: -79.82722222 },
          { lat: 24.71, lon: -79.84722222 },
          { lat: 24.69638889, lon: -79.8825 },
          { lat: 24.64222222, lon: -79.99944444 },
          { lat: 24.6075, lon: -80.06416667 },
          { lat: 24.555, lon: -80.21194444 },
          { lat: 24.55138889, lon: -80.2225 },
          { lat: 24.53694444, lon: -80.25444444 },
          { lat: 24.52416667, lon: -80.28194444 },
          { lat: 24.51583333, lon: -80.29638889 },
          { lat: 24.50388889, lon: -80.3225 },
          { lat: 24.50166667, lon: -80.32888889 },
          { lat: 24.49388889, lon: -80.35138889 },
          { lat: 24.47166667, lon: -80.40972222 },
          { lat: 24.46833333, lon: -80.41944444 },
          { lat: 24.45638889, lon: -80.45555556 },
          { lat: 24.44166667, lon: -80.49166667 },
          { lat: 24.41861111, lon: -80.53944444 },
          { lat: 24.39166667, lon: -80.6025 },
          { lat: 24.37583333, lon: -80.64888889 },
          { lat: 24.36861111, lon: -80.66416667 },
          { lat: 24.32527778, lon: -80.75583333 },
          { lat: 24.32111111, lon: -80.76305556 },
          { lat: 24.31055556, lon: -80.78027778 },
          { lat: 24.30972222, lon: -80.78166667 },
          { lat: 24.16416667, lon: -80.99638889 },
          { lat: 24.16333333, lon: -80.9975 },
          { lat: 24.14944444, lon: -81.01861111 },
          { lat: 24.14166667, lon: -81.03083333 },
          { lat: 24.14055556, lon: -81.0325 },
          { lat: 24.12444444, lon: -81.05166667 },
          { lat: 24.03888889, lon: -81.15138889 },
          { lat: 24, lon: -81.18777778 },
          { lat: 23.92555556, lon: -81.21527778 },
          { lat: 23.89777778, lon: -81.32861111 },
          { lat: 23.84777778, lon: -81.49972222 },
          { lat: 23.83388889, lon: -81.66638889 },
          { lat: 23.81805556, lon: -81.83305556 },
          { lat: 23.81805556, lon: -82.00305556 },
          { lat: 23.82833333, lon: -82.16638889 },
          { lat: 23.85388889, lon: -82.41638889 },
          { lat: 23.85388889, lon: -82.66638889 },
          { lat: 23.82833333, lon: -82.81472222 },
          { lat: 23.82555556, lon: -82.85305556 },
          { lat: 23.82333333, lon: -82.99972222 },
          { lat: 23.83111111, lon: -83.24972222 },
          { lat: 23.85611111, lon: -83.43027778 },
          { lat: 23.87416667, lon: -83.55027778 },
          { lat: 23.90111111, lon: -83.69305556 },
          { lat: 23.92972222, lon: -83.80305556 },
          { lat: 23.97722222, lon: -83.99972222 },
          { lat: 24.16027778, lon: -84.49083333 },
          { lat: 24.22222222, lon: -84.64416667 },
          { lat: 24.27805556, lon: -84.76861111 },
          { lat: 24.39166667, lon: -84.99972222 },
          { lat: 24.44361111, lon: -85.10527778 },
          { lat: 24.64916667, lon: -85.53166667 },
          { lat: 24.73805556, lon: -85.71972222 },
          { lat: 24.89916667, lon: -85.99972222 },
          { lat: 25.17888889, lon: -86.50194444 },
          { lat: 25.72083333, lon: -86.35388889 },
          { lat: 26.22027778, lon: -86.1125 },
          { lat: 26.45611111, lon: -86.22083333 },
          { lat: 26.56277778, lon: -86.61861111 },
          { lat: 26.02333333, lon: -87.49305556 },
          { lat: 25.70694444, lon: -88.55 },
          { lat: 25.78166667, lon: -90.49472222 },
          { lat: 25.74416667, lon: -90.78472222 },
          { lat: 25.86194444, lon: -91.88055556 },
          { lat: 26.29555556, lon: -93.06638889 },
          { lat: 25.99861111, lon: -93.56444444 },
          { lat: 26.00888889, lon: -95.6575 },
          { lat: 26.00916667, lon: -96.80833333 },
          { lat: 25.97555556, lon: -96.92444444 },
          { lat: 25.97083333, lon: -96.97805556 },
          { lat: 25.96611111, lon: -97.03166667 },
          { lat: 25.96138889, lon: -97.08555556 },
          { lat: 25.95666667, lon: -97.13916667 },
          { lat: 25.95666667, lon: -97.14638889 },
        ],
      },
    ],
  },
  {
    name: '美属加勒比海',
    property: '密闭',
    status: '已生效',
    emissionType: 'Nox，SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 17.31027778, lon: -67.53722222 },
          { lat: 19.18722222, lon: -67.44583333 },
          { lat: 19.50777778, lon: -65.28 },
          { lat: 19.20694444, lon: -65.10222222 },
          { lat: 18.75361111, lon: -65.00611111 },
          { lat: 18.68722222, lon: -64.9925 },
          { lat: 18.48944444, lon: -64.8975 },
          { lat: 18.45972222, lon: -64.88944444 },
          { lat: 18.4225, lon: -64.8775 },
          { lat: 18.40833333, lon: -64.87194444 },
          { lat: 18.3975, lon: -64.86388889 },
          { lat: 18.395, lon: -64.85638889 },
          { lat: 18.39333333, lon: -64.83805556 },
          { lat: 18.39666667, lon: -64.82805556 },
          { lat: 18.40305556, lon: -64.81666667 },
          { lat: 18.40777778, lon: -64.79916667 },
          { lat: 18.405, lon: -64.78361111 },
          { lat: 18.38694444, lon: -64.77694444 },
          { lat: 18.37694444, lon: -64.75555556 },
          { lat: 18.3775, lon: -64.745 },
          { lat: 18.37833333, lon: -64.74333333 },
          { lat: 18.37694444, lon: -64.74 },
          { lat: 18.3775, lon: -64.72833333 },
          { lat: 18.375, lon: -64.72666667 },
          { lat: 18.37361111, lon: -64.71611111 },
          { lat: 18.37388889, lon: -64.70777778 },
          { lat: 18.37083333, lon: -64.70083333 },
          { lat: 18.37277778, lon: -64.68333333 },
          { lat: 18.36583333, lon: -64.67083333 },
          { lat: 18.36416667, lon: -64.63972222 },
          { lat: 18.35611111, lon: -64.63777778 },
          { lat: 18.34416667, lon: -64.6425 },
          { lat: 18.32083333, lon: -64.63722222 },
          { lat: 18.31861111, lon: -64.63777778 },
          { lat: 18.28972222, lon: -64.66055556 },
          { lat: 18.27861111, lon: -64.66138889 },
          { lat: 18.1925, lon: -64.64944444 },
          { lat: 18.05055556, lon: -64.63416667 },
          { lat: 18.04888889, lon: -64.49305556 },
          { lat: 18.0475, lon: -64.45055556 },
          { lat: 18.04166667, lon: -64.35222222 },
          { lat: 18.04194444, lon: -64.33555556 },
          { lat: 18.03416667, lon: -64.26583333 },
          { lat: 18.00333333, lon: -64.04138889 },
          { lat: 17.99944444, lon: -64.01777778 },
          { lat: 17.97972222, lon: -63.95027778 },
          { lat: 17.96416667, lon: -63.89833333 },
          { lat: 17.94388889, lon: -63.88916667 },
          { lat: 17.66111111, lon: -63.91472222 },
          { lat: 17.61888889, lon: -63.91944444 },
          { lat: 17.50583333, lon: -63.93222222 },
          { lat: 17.19333333, lon: -63.96583333 },
          { lat: 17.08333333, lon: -63.97805556 },
          { lat: 16.99694444, lon: -63.98833333 },
          { lat: 17.31027778, lon: -67.53722222 },
        ],
      },
    ],
  },
  {
    name: '波罗的海',
    property: '开放',
    status: '已生效',
    emissionType: 'SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 62, lon: 5.35 },
          { lat: 62, lon: -4 },
          { lat: 58.55, lon: -4 },
        ],
      },
    ],
  },
  {
    name: '北海',
    property: '开放',
    status: '已生效',
    emissionType: 'SOx and particulate matter emission control',
    area: [
      {
        line: [
          { lat: 50.18, lon: -5 },
          { lat: 48.5, lon: -5 },
          { lat: 48.5, lon: -4.75 },
        ],
      },
    ],
  },
  {
    name: '中国沿海',
    property: '开放',
    status: '2019年1月1日',
    emissionType: '硫氧化物',
    area: [
      {
        line: [
          { lon: 124.188, lat: 39.8466 },
          { lon: 122.954, lat: 37.3699 },
          { lon: 122.95, lat: 37.3581 },
          { lon: 122.805, lat: 36.8976 },
          { lon: 122.754, lat: 36.807 },
          { lon: 122.683, lat: 36.7448 },
          { lon: 122.41, lat: 36.5858 },
          { lon: 121.051, lat: 35.7456 },
          { lon: 120.216, lat: 34.991 },
          { lon: 121.54, lat: 33.4795 },
          { lon: 121.854, lat: 33.1053 },
          { lon: 122.445, lat: 31.5357 },
          { lon: 123.392, lat: 30.8211 },
          { lon: 123.41, lat: 30.7644 },
          { lon: 123.158, lat: 30.0954 },
          { lon: 122.474, lat: 28.7921 },
          { lon: 122.125, lat: 28.3162 },
          { lon: 122.101, lat: 28.2838 },
          { lon: 121.32, lat: 27.3586 },
          { lon: 120.708, lat: 26.2924 },
          { lon: 120.603, lat: 26.0672 },
          { lon: 120.116, lat: 25.3103 },
          { lon: 119.624, lat: 24.8255 },
          { lon: 118.388, lat: 24.015 },
          { lon: 117.842, lat: 23.3879 },
          { lon: 117.374, lat: 23.0515 },
          { lon: 117.331, lat: 23.0258 },
          { lon: 116.582, lat: 22.7514 },
          { lon: 115.217, lat: 22.1342 },
          { lon: 114.036, lat: 21.6174 },
          { lon: 112.848, lat: 21.3738 },
          { lon: 112.489, lat: 21.2868 },
          { lon: 111.45, lat: 19.8661 },
          { lon: 111.395, lat: 19.7819 },
          { lon: 110.649, lat: 18.5196 },
          { lon: 110.628, lat: 18.5067 },
          { lon: 110.252, lat: 18.2669 },
          { lon: 110.157, lat: 18.2126 },
          { lon: 109.759, lat: 17.9842 },
          { lon: 109.718, lat: 17.9843 },
          { lon: 109.574, lat: 17.9551 },
          { lon: 109.061, lat: 18.053 },
          { lon: 108.845, lat: 18.1496 },
          { lon: 108.552, lat: 18.3522 },
          { lon: 108.528, lat: 18.375 },
          { lon: 108.519, lat: 18.3862 },
          { lon: 108.479, lat: 18.4263 },
          { lon: 108.413, lat: 18.8204 },
          { lon: 108.389, lat: 19.2131 },
          { lon: 108.379, lat: 20.4016 },
          { lon: 108.208, lat: 21.2099 },
          { lon: 108.134, lat: 21.2757 },
          { lon: 108.095, lat: 21.4524 },
          { lon: 108.094, lat: 21.4566 },
          { lon: 108.094, lat: 21.458 },
          { lon: 108.097, lat: 21.4611 },
          { lon: 108.099, lat: 21.4641 },
          { lon: 108.1, lat: 21.4673 },
          { lon: 108.101, lat: 21.4703 },
          { lon: 108.066, lat: 21.5118 },
        ],
      },
    ],
  },
  {
    name: '中国海南',
    property: '开放',
    status: '2019年1月1日',
    emissionType: '硫氧化物',
    area: [
      {
        line: [
          { lon: 108.5476, lat: 19.5182 },
          { lon: 109.0099, lat: 19.9057 },
          { lon: 109.0296, lat: 19.8091 },
          { lon: 109.1901, lat: 20.0872 },
          { lon: 109.414, lat: 20.1085 },
          { lon: 109.6097, lat: 20.19 },
          { lon: 109.9015, lat: 20.1877 },
          { lon: 110.158, lat: 20.2653 },
          { lon: 110.4808, lat: 20.2784 },
          { lon: 110.7047, lat: 20.3596 },
          { lon: 111.0689, lat: 20.1705 },
          { lon: 111.2034, lat: 19.8487 },
          { lon: 111.2694, lat: 19.5706 },
          { lon: 110.628, lat: 18.5067 },
          { lon: 110.252, lat: 18.2669 },
          { lon: 110.157, lat: 18.2126 },
          { lon: 109.759, lat: 17.9842 },
          { lon: 109.718, lat: 17.9843 },
          { lon: 109.574, lat: 17.9551 },
          { lon: 109.061, lat: 18.053 },
          { lon: 108.845, lat: 18.1496 },
          { lon: 108.552, lat: 18.3522 },
          { lon: 108.528, lat: 18.375 },
          { lon: 108.519, lat: 18.3862 },
          { lon: 108.479, lat: 18.4263 },
          { lon: 108.413, lat: 18.8204 },
          { lon: 108.389, lat: 19.2131 },
        ],
      },
    ],
  },
]
